import { combineReducers } from "redux";
import alertSettings from './Alert-Settings';
import alerts from "./Alerts";
import auth from "./Auth";
import global from "./Global";

export default combineReducers({
  alertSettings,
  alerts,
  auth,
  global,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js